import AuthProvider from '../../common/services/auth/AuthProvider/Index';
import { SortOrder } from '../hooks/usePaginatedKits';

export interface KitApiResponse {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
  from: number;
  to: number;
  items: any[];
}

/**
 * Creates a fetcher function for kits API calls
 * @param endpoint - The API endpoint (e.g., 'kits' or 'rsa-kits')
 * @returns A fetcher function compatible with usePaginatedKits
 */
export const createKitFetcher = (endpoint: string) => {
  return async (
    page: number,
    searchTerm: string,
    statusFilter: string | null,
    sortBy: string | null,
    sortOrder: SortOrder
  ): Promise<KitApiResponse> => {
    let url = `${process.env.REACT_APP_API_BASE_URL}/v1/private/provider/${endpoint}?page=${page}&pageSize=10`;
    if (searchTerm) {
      url += `&search=${encodeURIComponent(searchTerm)}`;
    }
    if (statusFilter) {
      url += `&status=${encodeURIComponent(statusFilter)}`;
    }
    if (sortBy) {
      url += `&sortBy=${encodeURIComponent(sortBy)}`;
    }
    if (sortOrder) {
      url += `&sortOrder=${encodeURIComponent(sortOrder)}`;
    }

    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${await AuthProvider.getValidAuthorizationToken()}`,
      },
    });

    if (response.status === 422) {
      throw new Error('Invalid email format. Please enter a valid email address.');
    }

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    return await response.json();
  };
};

